import React from "react";
import { View, StyleSheet } from "react-native";

import { mq } from "utils";
import { colors } from "assets/constants";

const ModalBar = () => <View style={styles.bar} />;
export default ModalBar;

const styles = StyleSheet.create({
  bar: {
    alignSelf: "center",
    width: 60,
    height: 5,
    borderRadius: 5,
    marginVertical: 25,
    backgroundColor: colors.textColorGray,
  },
});
